import { FLIGHTS_CB_SERVER } from "./Constants";

export const flightConfig = {
  liveMode: false,
  cssPath: "//cssak.mmtcdn.com/seo/hotels-new",
  jsPath: "//jsak.mmtcdn.com/seo/hotels-new",
  imagePath: "//imgak.mmtcdn.com/seo/hotels-new",
  airlineLogoPath: "//imgak.mmtcdn.com/air/pwa/dist/assets/img/airline-logos/{airlineCode}.gif",
  cacheMaxAge: 3600,
  resourceVersion: 237,
  routes:
    "new_delhi-patna,mumbai-bangalore,bangalore-pune,mumbai-nagpur,new_delhi-bhatinda,new_delhi-agra,new_delhi-mumbai,mumbai-new_delhi",
  seoSupportedCountries:
    "united_states,united_arab_emirates,oman,kuwait,saudi_arabia,bahrain,qatar",
  apiConfig: {
    pwaApi:
      "http://pwav2.makemytrip.com/pwa/flights-listing-seo?trip=oneWay&classtype=E&fromcity={src_city_code}&tocity={dest_city_code}&fromcityname={src_city_name}&tocityname={dest_city_name}&childcount=0&adultcount=1&infantcount=0&depdate={cheap_MMddyyyy}&isIntl=false",
    pwaScreenApi:
      "http://pwav2.makemytrip.com/pwa/flights-listing-screen-seo?trip=oneWay&classtype=E&fromcity={src_city_code}&tocity={dest_city_code}&fromcityname={src_city_name}&tocityname={dest_city_name}&childcount=0&adultcount=1&infantcount=0&depdate={cheap_MMddyyyy}&isIntl=false&count=10",
    cheapFareApi: "http://r2d2.mmt.mmt/R2D2/cheapestFareBulkQuery.htm",
    cheapFareApiV2: "http://r2d2.mmt.mmt/R2D2/v2/cheapestFareBulkQuery.htm",
    fareTrends:
      "http://flights.mmt.mmt/makemytrip/service/fareTrend/{src_city_code}-{dest_city_code}/{dd-MM-yyyy}/L0-R365.json",
    flightsFQDN: "http://flights.mmt.mmt",
    fareCalander:
      "http://flights-calendar.ecs.mmt/flights-calendar/fares?ond={src_city_code}_{dest_city_code}&bins=mmt_ow",
    fareCalanderV2:
      "http://flights-calendar.ecs.mmt/flights-calendar/v2021/fares?ond={src_city_code}_{dest_city_code}&lob=owc&dur=0&language=eng",
    mmtCommonHeaderUrl:
      "http://hcs.mmt.mmt/commonheader/services/getHeader?company=MMT&lob=SEO&page=LANDING",
    ifCheapRoutesApi:
      "//seo.mmt.mmt/international-flights/get_flight_node/mmt_cheap_international_routes?no_of_routes_required={num}",
    topIntlFlightsApi:
      "http://seo.mmt.mmt/international-flights/get_flight_node/mmt_top_international_flights",
    dealsApi: "http://destinationguide.mmt.mmt/rest/offers",
    destinationPickerIsmApi:
      "http://flights-ui-seo.ecs.mmt/flight/destinationPicker?sourcePage=SEO&tripType=O&&month=ANYTIME",
    flightIsmApi:
      "http://flights-ui-seo.ecs.mmt/flight/search?tripType=O&itinerary={src_city_code}-{dest_city_code}-{dateToBePassedInUrl60}&paxType=A-1&cabinClass=E&intl={isIntl}&ssr=true&device=desktop",
    flightIsmMobApi:
      "http://flights-ui-seo.ecs.mmt/flight/search?tripType=O&itinerary={src_city_code}-{dest_city_code}-{dateToBePassedInUrl60}&paxType=A-1&cabinClass=E&intl={isIntl}&ssr=true&device=pwa",
    flightIsmMobApiNew:
      "http://flights-ui-seo.ecs.mmt/flight/search?cabinClass=E&ccde={ccde}&deviceMemory=8&itinerary={src_city_code}-{dest_city_code}-{dateToBePassedInUrl60}&lang={lang}&msv=2&paxType=A-1_C-0_I-0&ssr=true&tripType=O&pwa=true&intl={isIntl}",
    flightIsmDTApiNew:
      "http://flights-ui-seo.ecs.mmt/flight/search?cabinClass=E&ccde={ccde}&deviceMemory=8&intl={isIntl}&itinerary={src_city_code}-{dest_city_code}-{dateToBePassedInUrl60}&lang={lang}&msExperiments=showFare:true&msv=2&paxType=A-1_C-0_I-0&ssr=true&tripType=O&pwa=false",
    flightIsmHeaderApi:
      "http://flights-ui-seo.ecs.mmt/flight/header?tripType=O&paxType=A-1&cabinClass=E&intl={isIntl}&ssr=true&device=desktop",
    flightIsmHeaderMobApi:
      "http://flights-ui-seo.ecs.mmt/flight/header?tripType=O&paxType=A-1&cabinClass=E&intl={isIntl}&ssr=true&device=pwa",
    flightIsmFilterApi:
      "http://flights-ui-seo.ecs.mmt/flight/search/applyAirlineFilter?device=desktop",
    flightIsmMobFilterApi:
      "http://flights-ui-seo.ecs.mmt/flight/search/applyAirlineFilter?device=pwa",
    fareFinderIsmMobApi:
      "http://flights-ui-seo.ecs.mmt/flight/fare-finder?tripType=O&paxType=A-1_C-0_I-0&cabinClass=E&itinerary={src_city_code}-{dest_city_code}-{mm-yyyy}&pwa=true",
    fareFinderIsmDTApi:
      "http://flights-ui-seo.ecs.mmt/flight/fare-finder?tripType=O&paxType=A-1_C-0_I-0&cabinClass=E&itinerary={src_city_code}-{dest_city_code}-{mm-yyyy}&pwa=false",
    intlFlightIsmApi:
      "http://intlflights-ism.mmt.mmt:3000/air/seo-ism/search?tripType=O&itinerary={src_city_code}-{dest_city_code}-D-{dateToBePassedInUrl60}&paxType=A-1&cabinClass=E&swExperiment=false",
    intlFlightIsmMobApi:
      "http://intlflights-ism.mmt.mmt:3001/pwa/seo-ism/flights-listing-intl?depdate={dateToBePassedInUrl60}&fromcity={src_city_code}&tocity={dest_city_code}&fromcityname={src_city_name}&tocityname={dest_city_name}&classtype=E&trip=oneWay&isIntl=true&adultcount=1&childcount=0&infantcount=0&depDate={dateToBePassedInUrl60}&fromCity={src_city_code}&toCity={dest_city_code}&fromCityName={src_city_name}&toCityName={dest_city_name}&classType=E&trip=oneWay&isIntl=true&adultCount=1&childCount=0&infantCount=0",
    intlFlightIsmFilterApi: "http://intlflights-ism.mmt.mmt:3000/air/seo-ism/applyAirlineFilter",
    intlFlightIsmMobFilterApi: "http://intlflights-ism.mmt.mmt:3001/pwa/seo-ism/applyAirlineFilter",
    offersApi:
      "http://flights-ui-seo.ecs.mmt/flight/offers?tripType=O&ccde={ccde}&itinerary={src_city_code}-{dest_city_code}-{dateToBePassedInUrl60}&paxType=A-1_C-0_I-0&cabinClass=E&intl={isIntl}&ssr=true&isPwa={isPwa}&lob={lob}&lang={lang}",
    offersMobApi: "https://hcs-promo.mmt.mmt/makemytrip/promov3/pwa/5.2.7/query?",
    flightListing: `${FLIGHTS_CB_SERVER}/api/search-dt?pax=A-1_C-0_I-0&cc=E&src=&crId={crId}&pfm=DESKTOP&cur=INR&shd=true&it={src_city_code}-{dest_city_code}-{yyyyMMdd}&sortBy=rhino&apiCallTimestamp={time_stamp}&forwardFlowRequired=true&clientType=SEO&rkeyTtlInMinutes=1440`,
    fareCalendarCB: `${FLIGHTS_CB_SERVER}/api/fareCalendar?crId={crId}&it={src_city_code}-{dest_city_code}-{yyyyMMdd}`,
    rKeyUrl:
      "https://www.makemytrip.com/flight/review/?ccde={ccde}&itineraryId={itineraryId}&rKey={rKey}&crId={crId}&cur=INR&openFF=undefined&xflt={xflt}",
    fareCalendarUrl:
      "https://www.makemytrip.com/flight/search?tripType=O&itinerary={src_city_code}-{dest_city_code}-{dd/MM/yyyy}&paxType=A-1&cabinClass=E&intl=false",
  },
  settings: {
    intlCms: {
      funnel_pwa_url:
        "//www.makemytrip.com/pwa/flights-listing?depdate=departure_date&fromcity=src_city_code",
      funnel_non_pwa_url:
        "//flights.makemytrip.com/makemytrip/directsearch.do?action=FLTSRCH&origin=[custom:funnel_src]&destination=[custom:funnel_dest]&cabinClass=E&tripType=O&depDate=date_2&retnDate=&noOfAdults=1&noOfChildren=0&noOfInfants=0&directFlight=&nightFlight=NF&refundable=&carrierList=&deptTime=Any% 20time&retnTime=Any%time",
      pwa_deep_link_search_button_oneway:
        "https://www.makemytrip.com/pwa/flights-listing-intl?depdate=departure_date&travellercount=traveller_count&classtype=class_type&fromcity=src_city_code&tocity=dest_city_code&fromcityname=src_city_name&tocityname=dest_city_name&adultcount=adult_value&childcount=child_value&infantcount=infant_value&trip=oneWay&isIntl=true",
      pwa_deep_link_search_button_twoway:
        "https://www.makemytrip.com/pwa/flights-listing-intl?depdate=departure_date&returndate=arrival_date&travellercount=traveller_count&classtype=class_type&fromcity=src_city_code&tocity=dest_city_code&fromcityname=src_city_name&tocityname=dest_city_name&adultcount=adult_value&childcount=child_value&infantcount=infant_value&trip=roundtrip&isIntl=true",
      pwa_deep_link_listing_oneway:
        "https://www.makemytrip.com/pwa/flights-listing-intl?depdate=departure_date&travellercount=1&classtype=E&fromcity=src_city_code&tocity=dest_city_code&fromcityname=src_city_name&tocityname=dest_city_name&adultcount=1&childcount=0&infantcount=0&trip=oneWay&isIntl=true",
      pwa_deep_link_listing_twoway:
        "https://www.makemytrip.com/pwa/flights-listing-intl?depdate=departure_date&returndate=arrival_date&travellercount=1&classtype=E&fromcity=src_city_code&tocity=dest_city_code&fromcityname=src_city_name&tocityname=dest_city_name&adultcount=1&childcount=0&infantcount=0&trip=roundtrip&isIntl=true",
      funnel_link: {
        intl: "//cheapfaresindia.makemytrip.com/international/raw/index.html?l=exIndia&t=OW&i=[src_city]-[dest_city]-D-[dept_date]&p=A-1&c=E#/listing",
        us: "//cheapfaresindia.makemytrip.com/international/international/direct?tt=r&frm=",
        ae: "http://www.makemytrip.ae/international/international/direct?tt=R&rd=",
      },
      new_funnel_settings: {
        new_funnel_enable: "1",
        new_funnel_link: {
          intl: "https://www.makemytrip.com/air/search?tripType=O&itinerary=[src_city]-[dest_city]-D-[dept_date]&paxType=A-1&cabinClass=E",
        },
      },
      funnel_search: {
        oneway:
          "https://www.makemytrip.com/air/search?tripType=O&itinerary=src_code-dest_code-D-dep_date&paxType=A-adult-C-child-I-infrant&cabinClass=E",
        retway:
          "https://www.makemytrip.com/air/search?tripType=R&itinerary=src_code-dest_code-D-dep_date_dest_code-src_code-D-arr_date&paxType=A-adult-C-child-I-infrant&cabinClass=E",
      },
      mmt_common: {
        seo_pat_check: ["google"],
        seo_add_vars: "SEO",
        seo_bot_pattern_key: "tsource",
      },
    },
    funnel_pwa_url:
      "//www.makemytrip.com/pwa/flights-listing?depdate=departure_date&travellercount=traveller_count&classtype=class_type&fromcity=src_city_code&tocity=dest_city_code&fromcityname=src_city_name&tocityname=dest_city_name&adultcount=adult_value&childcount=child_value&infantcount=infant_value&trip=oneWay&isIntl=false",
    funnel_non_pwa_url:
      "//flights.makemytrip.com/makemytrip/directsearch.do?action=FLTSRCH&origin=[custom:funnel_src]&destination=[custom:funnel_dest]&cabinClass=E&tripType=O&depDate=date_2&retnDate=&noOfAdults=1&noOfChildren=0&noOfInfants=0&directFlight=&nightFlight=NF&refundable=&carrierList=&deptTime=Any% 20time&retnTime=Any%time",
    funnel_listing_unification_url:
      "//www.makemytrip.com/flight/search?tripType=O&itinerary={itinerary}&paxType=A-1&cabinClass=E&intl={intl}",
  },
};

const GOIBIBO_SEARCH_URL = "https://www.goibibo.com/flight/search";

const goibiboSearchUrl = (itinerary, paxType = "A-1", intl = "{intl}") =>
  `${GOIBIBO_SEARCH_URL}?tripType=O&itinerary=${itinerary}&paxType=${paxType}&cabinClass=E&intl=${intl}&cmpid=SEO`;

const goibiboRoundTripSearchUrl = (itinerary, paxType = "A-1", intl = "true") =>
  `${GOIBIBO_SEARCH_URL}?tripType=R&itinerary=${itinerary}&paxType=${paxType}&cabinClass=E&intl=${intl}&cmpid=SEO`;

export const goibiboFlightSettings = {
  ...flightConfig.settings,
  intlCms: {
    ...flightConfig.settings.intlCms,
    funnel_pwa_url: goibiboSearchUrl("src_city_code-dest_city_code-departure_date", "A-1", "true"),
    funnel_non_pwa_url: goibiboSearchUrl("[custom:funnel_src]-[custom:funnel_dest]-date_2", "A-1", "true"),
    pwa_deep_link_search_button_oneway: goibiboSearchUrl(
      "src_city_code-dest_city_code-departure_date",
      "A-adult_value_C-child_value_I-infant_value",
      "true",
    ),
    pwa_deep_link_search_button_twoway: goibiboRoundTripSearchUrl(
      "src_city_code-dest_city_code-departure_date_dest_city_code-src_city_code-arrival_date",
      "A-adult_value_C-child_value_I-infant_value",
      "true",
    ),
    pwa_deep_link_listing_oneway: goibiboSearchUrl(
      "src_city_code-dest_city_code-departure_date",
      "A-1_C-0_I-0",
      "true",
    ),
    pwa_deep_link_listing_twoway: goibiboRoundTripSearchUrl(
      "src_city_code-dest_city_code-departure_date_dest_city_code-src_city_code-arrival_date",
      "A-1_C-0_I-0",
      "true",
    ),
    funnel_link: {
      intl: goibiboSearchUrl("[src_city]-[dest_city]-D-[dept_date]", "A-1", "true"),
      us: goibiboSearchUrl("[src_city]-[dest_city]-D-[dept_date]", "A-1", "true"),
      ae: goibiboSearchUrl("[src_city]-[dest_city]-D-[dept_date]", "A-1", "true"),
    },
    new_funnel_settings: {
      new_funnel_enable: "1",
      new_funnel_link: {
        intl: goibiboSearchUrl("[src_city]-[dest_city]-D-[dept_date]", "A-1", "true"),
      },
    },
    funnel_search: {
      oneway: goibiboSearchUrl("src_code-dest_code-D-dep_date", "A-adult_C-child_I-infrant", "true"),
      retway: goibiboRoundTripSearchUrl(
        "src_code-dest_code-D-dep_date_dest_code-src_code-D-arr_date",
        "A-adult_C-child_I-infrant",
        "true",
      ),
    },
  },
  funnel_pwa_url: goibiboSearchUrl(
    "src_city_code-dest_city_code-departure_date",
    "A-adult_value_C-child_value_I-infant_value",
    "false",
  ),
  funnel_non_pwa_url: goibiboSearchUrl("[custom:funnel_src]-[custom:funnel_dest]-date_2", "A-1", "false"),
  funnel_listing_unification_url: goibiboSearchUrl("{itinerary}"),
};

export const goibiboFlightConfigOverrides = {
  apiConfig: {
    pwaApi: goibiboSearchUrl(
      "{src_city_code}-{dest_city_code}-{cheap_MMddyyyy}",
      "A-1_C-0_I-0",
      "false",
    ),
    pwaScreenApi: goibiboSearchUrl(
      "{src_city_code}-{dest_city_code}-{cheap_MMddyyyy}",
      "A-1_C-0_I-0",
      "false",
    ),
    flightsFQDN: GOIBIBO_SEARCH_URL.replace("/flight/search", ""),
    mmtCommonHeaderUrl: "http://hcs.mmt.mmt/commonheader/services/getHeader?company=GI&lob=SEO&page=LANDING",
    rKeyUrl:
      "https://www.goibibo.com/flight/review/?ccde={ccde}&itineraryId={itineraryId}&rKey={rKey}&crId={crId}&cur=INR&openFF=undefined&xflt={xflt}",
    fareCalendarUrl: goibiboSearchUrl(
      "{src_city_code}-{dest_city_code}-{dd/MM/yyyy}",
      "A-1",
      "false",
    ),
  },
  settings: goibiboFlightSettings,
};

export const getFlightSettings = (isGoibibo = false) =>
  isGoibibo ? goibiboFlightSettings : flightConfig.settings;

export const applyGoibiboFlightConfig = (appConfig) => {
  if (!appConfig) return appConfig;
  return {
    ...appConfig,
    apiConfig: {
      ...appConfig.apiConfig,
      ...goibiboFlightConfigOverrides.apiConfig,
    },
    settings: goibiboFlightSettings,
  };
};
